import { Component, Input, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { ControlContainer } from '@angular/forms';

import { ConsultaPreviaModel } from '../../models/consulta-previa.model';

import { ConsultaPreviaService } from '../../services/consulta-previa.service';
import { UsuarioService } from '../../../pages/usuario/usuario.service';
import { IbgeService } from '../../services/ibge.service';
import { MessageService } from '../../messages/message.service';

import { Util } from '../../utils/util';
import { ContatoFormComponent } from '../contato/contato.component';
import { ToastrService } from 'ngx-toastr';


@Component({
    // tslint:disable-next-line:component-selector
    selector: 'consulta-previa-representante-pf',
    templateUrl: './consulta-previa-representante-pf.component.html',
    styleUrls: ['./consulta-previa-representante-pf.component.scss']
})
export class ConsultaPreviaRepresentantePfFormComponent implements OnInit {

    @ViewChild('ContatoComponent', { static: false }) private contatoComponent: ContatoFormComponent;

    @Input() pageMode: any;
    @Input() isRepresentanteLegal = false;
    @Input() isResponsavel = false;
    @Input() isLocalAtendimento = false;
    @Input() showContato = true;
    @Input() showLimparCampos = true;
    @Output() outputLimparFiltros = new EventEmitter();
    @Output() outputCarregaUsuario = new EventEmitter();

    // Objeto para consulta prévia
    consultaPreviaObj: ConsultaPreviaModel;
    // Variáveis para controle do blur
    isConsultaDadosUsuarioActive = true;
    isConsultaPreviaActive = false;
    // Listas dos combos
    listaEstados: any;
    listaOrgaos: any;

    constructor(
        public controlContainer: ControlContainer,
        private usuarioService: UsuarioService,
        private consultaPreviaService: ConsultaPreviaService,
        private ibgeService: IbgeService,
        private messageService: MessageService,
        private toastr: ToastrService
    ) { }

    ngOnInit() {
        if (this.isRepresentanteLegal) {
            // Carrega os dados de UF
            this.ibgeService.getListEstados()
                .subscribe(dados => {
                    this.listaEstados = Util.orderBy(dados, 'Sigla');
                });
        }
    }

    onblurConsultaDadosUsuario() {
        if (this.controlContainer.control.get('CPF').enable) {
            if (this.controlContainer.control.get('CPF').value !== '') {
                this.usuarioService.getByCPF(this.controlContainer.control.get('CPF').value)
                    .subscribe(dados => {
                        if (dados != null) {
                            // Preenche os campos e desabilita
                            this.preencheDados(dados);
                            // Habilita os campos selecionados
                            this.habilitaEdicao();
                        } else {
                            this.messageService.handleMessage({
                                title: 'Não encontrado!',
                                text: 'Não foi encontrado nenhum usuário com o CPF informado, por favor preencha os dados para inclusão.',
                                 icon: 'warning'
                            });
                            // Libera os campos após a mensagem para preenchimento
                            this.controlContainer.control.enable();
                            this.controlContainer.control.get('Nome').disable();
                            // Habilita a consulta prévia
                            this.isConsultaPreviaActive = true;
                        }
                    },
                        () => {
                            this.toastr.warning('Ocorreu um erro ao realizar a consulta do usuário, realize a consulta prévia.', 'Atenção!');
                            this.isConsultaPreviaActive = true;
                        });
            } else {
                this.messageService.handleMessage({
                    title: 'Oops!',
                    text: 'Você precisa informar um CPF válido.',
                     icon: 'warning'
                });
            }
        }

    }

    onblurConsultaPrevia() {
        if (this.controlContainer.control.get('CPF').enable) {
            this.consultaPreviaObj = new ConsultaPreviaModel();
            this.consultaPreviaObj.cpf = this.controlContainer.control.get('CPF').value;
            this.consultaPreviaObj.dtNascimento = this.controlContainer.control.get('DtNascimento').value;
            this.consultaPreviaObj.documentoTipo = 1; // consulta CPF

            this.consultaPreviaService.realizarConsultaPrevia(this.consultaPreviaObj)
                .subscribe(
                    dados => {
                        // Código diferente de 0 indica não sucesso
                        if (dados.Codigo === 0) {
                            this.controlContainer.control.get('Nome').setValue(dados.Mensagem);
                            // Desabilita todos campos
                            this.controlContainer.control.disable();
                            // Habilita os campos selecionados
                            this.habilitaEdicao();
                        } else if (dados.Codigo === 700) {
                            this.isConsultaPreviaActive = true;
                            // Desabilita todos campos
                            this.controlContainer.control.get('CPF').disable();

                            if (this.pageMode === 3) {
                                this.enableFormFields();
                            }
                        } else if (dados.Codigo === 4) {
                            this.isConsultaPreviaActive = true;

                            if (this.controlContainer.control.get('DtNascimento').disabled) {
                                this.controlContainer.control.get('DtNascimento').enable();
                            }

                            this.messageService.handleMessage({
                                title: 'Oops!',
                                text: 'Data de Nascimento incorreta.',
                                 icon: 'warning'
                            });

                        } else {
                            this.messageService.handleMessage({
                                title: 'Oops!',
                                text: 'Verifique os dados informados :(',
                                 icon: 'warning'
                            });

                        }
                    },
                    () => {
                        this.enableNameForm();
                    });
        }
    }

    private enableFormFields() {
        this.messageService.handleMessage({
            title: 'Consulta prévia indisponível!',
            text: 'Preencha os campos necessários manualmente ou aguarde a volta da consulta.',
             icon: 'error'
        });
        this.controlContainer.control.get('DtNascimento').enable();
        this.controlContainer.control.get('Nome').enable();
    }

    /**
     * Habilita o campo de nome caso a receita esteja fora.
     */
    private enableNameForm() {
        this.messageService.handleMessage({
            title: 'Oops!',
            text: 'Ocorreu um erro ao realizar a consulta prévia :(',
             icon: 'error'
        });
        this.controlContainer.control.get('Nome').enable();
    }

    preencheDados(pessoa) {
        this.controlContainer.control.patchValue(pessoa);
        // Caso seja representante, popula os dados de OrgãoEmissor e UF
        if (this.isRepresentanteLegal) {
            this.controlContainer.control.patchValue({
                Documento: {
                    OrgaoEmissor: {
                        idOrgaoEmissor: pessoa.Documento.OrgaoEmissor.idOrgaoEmissor
                    }
                },
                UF: {
                    CodigoIBGE: this.listaEstados.filter(uf => uf.Sigla === pessoa.UF.Sigla)[0].CodigoIBGE
                }
            });
        }
        // Ajusta a data
        this.controlContainer.control.get('DtNascimento')
            .setValue(Util.convertDataToUTC(this.controlContainer.control.get('DtNascimento').value));
        // Atualiza os validators
        this.controlContainer.control.updateValueAndValidity();
        // Desabilita todos campos
        this.controlContainer.control.disable();
        // Se o usuário tiver não possuir um tipo o campo deve estar liberado
        if (this.controlContainer.control.get('TipoUsuario') && pessoa.TipoUsuario <= 0) {
            this.controlContainer.control.get('TipoUsuario').setValue(-1);
            this.controlContainer.control.get('TipoUsuario').enable();
        }
        if (this.controlContainer.control.get('searchText')) {
            this.controlContainer.control.get('searchText').enable();
        }
        this.outputCarregaUsuario.emit();
    }

    habilitaEdicao() {
        // Habilita os campos para edição do representante
        if (this.isRepresentanteLegal) {
            this.controlContainer.control.get('UF').enable();
            this.controlContainer.control.get('Documento').enable();
            this.controlContainer.control.get('Cargo').enable();
        }
        if (this.controlContainer.control.get('TipoUsuario') && this.controlContainer.control.get('TipoUsuario').value <= 0) {
            this.controlContainer.control.get('TipoUsuario').setValue(-1);
            this.controlContainer.control.get('TipoUsuario').enable();
        }
        // Validação para casos de formControl de pesquisa (Usuário)
        if (this.controlContainer.control.get('searchText')) {
            this.controlContainer.control.get('searchText').enable();
        }
        this.controlContainer.control.get('Contato').enable();
    }

    limparConsulta() {
        // Limpa a consulta e volta o componente ao estado inicial
        this.isConsultaDadosUsuarioActive = true;
        this.isConsultaPreviaActive = false;
        // Habilita os campos e limpa
        if (this.isRepresentanteLegal) {
            this.controlContainer.control.get('idRepresentanteLegal').setValue(null);
        } else if (this.isResponsavel) {
            this.controlContainer.control.get('idResponsavel').setValue(null);
        } else {
            this.controlContainer.control.get('idUsuario').setValue(null);
        }
        this.controlContainer.control.get('Nome').setValue(null);
        this.controlContainer.control.get('CPF').setValue(null);
        this.controlContainer.control.get('CPF').enable();
        this.controlContainer.control.get('DtNascimento').setValue(null);
        this.controlContainer.control.get('DtNascimento').enable();

        if (this.controlContainer.control.get('TipoUsuario')) {
            this.controlContainer.control.get('TipoUsuario').setValue(-1);
            this.controlContainer.control.get('TipoUsuario').enable();
        }
        if (this.controlContainer.control.get('searchText')) {
            this.controlContainer.control.get('searchText').enable();
        }
        this.contatoComponent.limparContato();

        this.outputLimparFiltros.emit();
    }
}
